import { format, utcToZonedTime } from 'date-fns-tz';

export function convertToLocalTimeZoneDate(utcDate: string) {
    return utcDate ? format(utcToZonedTime(utcDate, Intl.DateTimeFormat().resolvedOptions().timeZone), 'yyyy.MM.dd HH.mm.ss') : '';
}

export function convertToLocalTimeZoneHourMinute(utcDate: string) {
    return utcDate ? format(utcToZonedTime(utcDate, Intl.DateTimeFormat().resolvedOptions().timeZone), 'HH.mm') : '';
}

